import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const Manage = (properties: iconType) => (
  <SvgIcon
    {...properties}
    viewBox="0 0 25 22"
    style={{ fill: 'none', width: '40px', height: '24px', strokeWidth: '.08rem' }}
  >
    <path d="M24.0001 15.591V7.71436H9.68898C8.55942 7.71436 7.64453 8.59654 7.64453 9.68353V15.591H24.0001V15.591Z" />
    <path d="M14.8003 0.822266H24.0003V7.71436H12.7559L14.8003 0.822266V0.822266Z" />
    <path d="M15.9668 5.74872L16.8439 2.79102H19.3994" />
    <path d="M1 3.28418L3.55556 6.23793V17.0683L1 20.0221" />
    <path d="M3.55566 11.6528H7.64455" />
    <path d="M3.55566 13.6216H7.64455" />
    <path d="M10.2002 9.68311H14.2891" />
    <path d="M10.2002 11.6528H14.2891" />
    <path d="M7.64453 18.0523C7.64453 19.412 8.7884 20.5137 10.2001 20.5137H21.4445C22.8562 20.5137 24.0001 19.412 24.0001 18.0523C24.0001 16.6926 22.8562 15.5908 21.4445 15.5908H10.2001C8.7884 15.5908 7.64453 16.6926 7.64453 18.0523V18.0523Z" />
    <path d="M12.2446 18.0529C12.2446 18.5964 11.7877 19.0375 11.2224 19.0375C10.6571 19.0375 10.2002 18.5964 10.2002 18.0529C10.2002 17.5085 10.6571 17.0684 11.2224 17.0684C11.7877 17.0684 12.2446 17.5085 12.2446 18.0529V18.0529Z" />
    <path d="M16.8442 18.0529C16.8442 18.5964 16.3873 19.0375 15.822 19.0375C15.2567 19.0375 14.7998 18.5964 14.7998 18.0529C14.7998 17.5085 15.2567 17.0684 15.822 17.0684C16.3873 17.0684 16.8442 17.5085 16.8442 18.0529V18.0529Z" />
    <path d="M21.4448 18.0529C21.4448 18.5964 20.9879 19.0375 20.4226 19.0375C19.8573 19.0375 19.4004 18.5964 19.4004 18.0529C19.4004 17.5085 19.8573 17.0684 20.4226 17.0684C20.9879 17.0684 21.4448 17.5085 21.4448 18.0529V18.0529Z" />
  </SvgIcon>
);

export default Manage;
